// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"EditTabModal_buttonsWrapper__ZQtXO"};